import { menuAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { defineStyle } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  menuAnatomy.keys
);

const baseStyleList = defineStyle({});

const baseStyleItem = defineStyle({
  _hover: {
    bg: "accentLight",
  },
});

const baseStyleIcon = defineStyle({});

const baseStyleGroupTitle = defineStyle({});

const baseStyleCommand = defineStyle({});

const baseStyleDivider = defineStyle({});

const baseStyleButton = defineStyle({});

const baseStyle = definePartsStyle({
  button: baseStyleButton,
  list: baseStyleList,
  item: baseStyleItem,
  groupTitle: baseStyleGroupTitle,
  command: baseStyleCommand,
  divider: baseStyleDivider,
  icon: baseStyleIcon,
});

export const menuTheme = defineMultiStyleConfig({ baseStyle });
